import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import get from 'lodash/get';
import isString from 'lodash/isString';

import css from './index.css';
import sharedCSS from '~/components/shared.css';
import KEYS from '~/misc/keys';
import {toggleDropdown} from '~/modules/dropdowns/actions';
import mapDispatch from '~/misc/mapDispatch';

const isToggled = (props) => Boolean(props.dropdowns[props.id]);

class DropDown extends React.Component {
  constructor(props) {
    super(props);

    this.saveNode = this.saveNode.bind(this);
    this.saveContainer = this.saveContainer.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onDocumentFocusChange = this.onDocumentFocusChange.bind(this);
    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.handleMenuClick = this.handleMenuClick.bind(this);
  }

  componentWillMount() {
    if (isToggled(this.props)) {
      this.documentSubscribing(true);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (isToggled(nextProps) !== isToggled(this.props)) {
      this.documentSubscribing(isToggled(nextProps));
    }
  }

  componentWillUnmount() {
    this.documentSubscribing(false);
    if (isToggled(this.props)) {
      this.props.toggle();
    }
  }

  render() {
    const toggled = isToggled(this.props);
    let trigger = this.props.trigger;
    if (toggled && !isString(get(this.props.trigger, 'type'))) {
      trigger = React.cloneElement(this.props.trigger, {toggled});
    }
    
    return (
      <div
        className={cs(css.wrap, this.props.wrapClassName, 'qa-dropdown')}
        data-qa={this.props['data-qa']}
        ref={this.saveContainer}
      >
        <div onClick={!this.props.manualControl && this.handleTriggerClick} className='qa-dropdown-tigger'>
          {trigger}
          {this.props.icon && <span className={cs(css.downArrow, toggled && css.active)} />}
        </div>
        {this.renderContent()}
      </div>
    );
  }

  renderContent() {
    if (!isToggled(this.props)) {
      return null;
    }
    return (
      <div
        className={cs(
          css.select,
          sharedCSS.dropdown,
          this.props.dropDownClassName,
          {
            [css.toRight]: this.props.toRight,
            [css.overFlowScrolly]: this.props.contentOverFlowScrolly,
          },
          'qa-dropdown-content'
        )}
        ref={this.saveNode}
        onClick={!this.props.manualControl && (this.props.closeByClick ? null : this.handleMenuClick)}
      >
        {this.props.content}
      </div>
    );
  }

  handleMenuClick(e) {
    e.nativeEvent.stopImmediatePropagation();
  }

  handleTriggerClick(e) {
    e.preventDefault();
    this.props.toggle();
    // this.props.click()
  }

  saveNode(node) {
    this.selectNode = node;
  }

  saveContainer(node) {
    this.container = node;
  }

  onKeyPress(e) {
    if (e.keyCode === KEYS.ESC) {
      this.props.toggle(e);
    } else if (this.props.onKeyPress) {
      if (this.props.onKeyPress(e.keyCode, e)) {
        this.props.toggle(e);
      }
    }

    if (this.props.allowKeyboard) {
      return true;
    }

    e.stopPropagation();
    e.preventDefault();

    return null;
  }

  documentSubscribing(subscribe) {
    if (this.props.manualControl) {
      return;
    }

    const doEventing = subscribe ? 'addEventListener' : 'removeEventListener';

    document[doEventing]('click', this.props.toggle);
    document[doEventing]('keydown', this.onKeyPress);
    document[doEventing]('focus', this.onDocumentFocusChange, true);
  }

  toggle() {
    toggleDropdown(this.props.id);
  }

  onDocumentFocusChange(e) {
    let isChild = false;

    let cur = e.target;
    while (cur.parentNode) {
      isChild = cur.parentNode === this.container;
      if (isChild) {
        break;
      }
      cur = cur.parentNode;
    }

    if (!isChild) {
      this.props.toggle();
    }
  }
}

export default connect(
  state => ({dropdowns: state.dropdowns}),
  mapDispatch({
    toggle: ({id}) => toggleDropdown(id),
  }),
  null,
  {withRef: true}
)(DropDown);



// WEBPACK FOOTER //
// ./src/components/common/DropDown/index.js